<div class="acc-goals-and-progress-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="areaService.data()?.goalsAndProgress ?? []"></grid-content>
</div>